"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _SideBar = _interopRequireDefault(require("./SideBar"));
var _Users = _interopRequireDefault(require("./Users"));
var _EditEmail = _interopRequireDefault(require("./EditEmail"));
var _UserAdd = _interopRequireDefault(require("./UserAdd"));
var _UserEdit = _interopRequireDefault(require("./UserEdit"));
var _Status = _interopRequireDefault(require("./Status"));
var _Style = require("../../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function App() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.fill),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      ...stylex.props(_Style.wrapper.sidebarOuter),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBar.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_wouter.Switch, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/users",
          component: _Users.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/change-email",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditEmail.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/user/add",
          component: _UserAdd.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/user/edit/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserEdit.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/user/edit-email/:id",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditEmail.default, {
            id: params.id
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "/status",
          children: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Status.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Route, {
          path: "*",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Redirect, {
            to: "/users"
          })
        })]
      })
    })]
  });
}
var _default = exports.default = App;